import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SetErrorBar from 'utils/SetErrorBar';
import { ElementProps } from 'utils/Types';
import { useLang } from 'utils/lang/useLang';

const AuthGuard = ({ children }: ElementProps) => {
  const lang = useLang();
  const navigate = useNavigate();

  const targetStorage = localStorage.getItem('accessToken')
    ? localStorage
    : sessionStorage;
  const accessToken = targetStorage.getItem('accessToken');

  useEffect(() => {
    if (!accessToken) {
      SetErrorBar(lang.message.loginRequired);
      navigate('/login', { replace: true });
    }
  }, []);

  if (!accessToken) {
    return null;
  }
  return children;
};

export default AuthGuard;
